import BrandLockup from '../components/BrandLockup'
import './NotFound.css'

const BACKGROUND_VIDEO_URL =
  'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260801_001207_ec20d138-aa45-4b2b-ab8c-bdc71607f240.mp4'

export default function NotFound() {
  return (
    <main className='not-found'>
      <video
        className='not-found__video'
        src={BACKGROUND_VIDEO_URL}
        autoPlay
        loop
        muted
        playsInline
        aria-hidden='true'
      />
      <BrandLockup
        className='not-found__brand'
        markClassName='not-found__brand-mark'
        wordmarkClassName='not-found__brand-wordmark'
        label='Thoughtseed'
      />
      <div className='not-found__content'>
        <h1 className='not-found__code'>404</h1>
        <div className='not-found__divider' aria-hidden='true' />
        <p className='not-found__message'>
          The path may be broken, but the journey isn't. Let's get you back.
        </p>
      </div>
    </main>
  )
}
